import React, { useLayoutEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import Formatter from "../../../../services/utils/Formatter";
// import Forecast from "../../../../services/api/Forecast";

am4core.useTheme(am4themes_animated);

interface WaterfallProps {
	id: string;
	data: any[];
	classes?: string;
}

const Waterfall: React.FC<WaterfallProps> = ({ id, data, classes }) => {
	function formatData(data: any) {
		const fd: any = [];
		for (let i = 0; i < data.length; i++) {
			const obj = data[i];
			const firstOrLast = i === 0 || i === (data.length - 1);
			const base = firstOrLast ? 0 : fd[i - 1].stepValue;
			const value = base + obj.value;
			fd.push({
				category: obj.category,
				value: value,
				open: base, // valor inicial de Y
				stepValue: i === (data.length - 1) ? 0 : value, // barra de ligação
				color: firstOrLast ? "#f6f8fc" : (obj.value > 0 ? "#00162b" : "#C3093B"),
				displayValue: Number.isNaN(obj.value) || obj.value === undefined ? "" : obj.value
			});
		}
		return fd;
	}

	useLayoutEffect(() => {
		let x = am4core.create(id, am4charts.XYChart);

		x.hiddenState.properties.opacity = 0;
		x.background.visible = false;
		x.data = formatData(data);

		x.language.locale["_decimalSeparator"] = ",";
		x.language.locale["_thousandSeparator"] = "."; 

		//Config das categorias(nomes dos países)
		var categoryAxis = x.xAxes.push(new am4charts.CategoryAxis());
		categoryAxis.dataFields.category = "category";
		categoryAxis.renderer.grid.template.disabled = true;
		categoryAxis.renderer.minGridDistance = 5;
		categoryAxis.renderer.labels.template.fontSize = 16;
		categoryAxis.renderer.labels.template.fill = am4core.color("#00162b");
		categoryAxis.renderer.grid.template.location = 0;

		var label = categoryAxis.renderer.labels.template;
		label.wrap = true;
		label.maxWidth = 120;

		var valueAxis = x.yAxes.push(new am4charts.ValueAxis());

		var columnSeries = x.series.push(new am4charts.ColumnSeries());
		columnSeries.dataFields.categoryX = "category";
		columnSeries.dataFields.openValueY = "open";
		columnSeries.dataFields.valueY = "value";

		columnSeries.fillOpacity = 1;
		columnSeries.sequencedInterpolation = true;
		columnSeries.interpolationDuration = 1500;

		var columnTemplate = columnSeries.columns.template;
		columnTemplate.strokeOpacity = 0;
		columnTemplate.propertyFields.fill = "color";

		var bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
		//bullet.label.text = "{displayValue.formatNumber('#,###.')}";
		bullet.label.text = "{displayValue}";
		bullet.label.hideOversized = false;
		bullet.label.fill = am4core.color("#00162b");
		bullet.label.fontSize = 12;
		//impede que o bullet label seja cortado
		x.maskBullets = false;

		bullet.label.adapter.add("verticalCenter", function (center, target) {
			if (!target.dataItem) {
				return center;
			}
			//Varifica se os valores são positivos ou negativos
			var values = target.dataItem.values;
			if (values.openValueY.value <= 0) return "bottom";
			return values.valueY.value > values.openValueY.value ? "bottom" : "top";
		});

		//Desenha as linhas que conectam as colunas
		var stepSeries = x.series.push(new am4charts.StepLineSeries());
		stepSeries.dataFields.categoryX = "category";
		stepSeries.dataFields.valueY = "stepValue";
		stepSeries.noRisers = true;
		stepSeries.stroke = am4core.color("#eaeff8");
		stepSeries.strokeDasharray = "1";
		stepSeries.interpolationDuration = 2000;
		stepSeries.sequencedInterpolation = true;

		// because column width is 80%, we modify start/end locations so that step would start with column and end with next column
		stepSeries.startLocation = 0.1;
		stepSeries.endLocation = 1.1;

		//Esconde o grid do fundo e os labels laterais
		valueAxis.renderer.grid.template.disabled = true;
		valueAxis.renderer.labels.template.disabled = true;

		return () => {
			x.dispose();
		};
	}, [data]);

	return <div className={"chart " + classes} id={id}></div>;
}

export default Waterfall;
